<div class="custom-table">
	<!-- Header -->
	<div class="row custom-table-header">
		<div class="col-sm-auto header-icon">
			<span class="material-icons">privacy_tip</span>
		</div>
		<div class="col align-self-center" i18n>App</div>

		<!-- App key selection -->
		<div class="col-sm-auto select mr-1 pr-0 align-self-center" *ngIf="appKeys.length > 1">
			<mat-form-field appearance="standard" dense class="mr-2">
				<mat-select [formControl]="appKeySelect" i18n-placeholder placeholder="All" panelClass="mat-select-multi-line">
					<mat-option i18n>All</mat-option>
					<mat-option
						*ngFor="let appKey of appKeys"
						[value]="appKey"
					>
						{{appKey.name}}
						<div>
							<span
								class="badge badge-pill badge-secondary deploy-badge mt-1 mr-2 py-1 px-2 text-capitalize {{ appKey.provider != 'local' ? 'badge-' + appKey.provider : '' }}"
							>{{appKey.provider}}</span>
							<span
								class="badge badge-pill badge-secondary deploy-badge mt-1 mr-2 py-1 px-2"
							>{{ getClusterName(appKey.clusterId) }}</span>
							<span
								class="badge badge-pill badge-info deploy-badge mt-1 mr-2 py-1 px-2"
							>{{ appKey.clientId }}</span>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<!-- END App key selection -->

		<div class="col-sm-auto small-btn pl-0 align-self-center" [hidden]="!editable">
			<button mat-icon-button class="btn-sm add-btn app-legal__add" type="button" (click)="addLegal()">
				<span class="material-icons align-middle">add_circle_outline</span>
			</button>
		</div>
	</div>
	<!-- END Header -->

	<!-- Body -->
	<app-loader-wrapper [loading]="loading" size="sm" class="custom-table-body">
		<!-- App Legals -->
		<div class="row align-items-center mx-0 p-1 bordered-top" *ngIf="legals.length === 0 && !loading" style="min-height: 44px;">
			<div class="col-12" i18n>
				No documents have been uploaded to your company yet. <span [hidden]="!editable"><button class="button-link" type="button" (click)="addLegal()">
					Upload
				</button> your first document to get started!</span>
			</div>
		</div>

		<div id="{{term.termsId}}" class="row align-items-center mx-0 p-1 bordered-top" *ngFor="let term of legalsFiltered">
			<div class="col">
				<div class="document-name mb-1">{{ term.displayName }}</div>
				<div class="contact-name" *ngIf="term?.alias">
					<span class="pr-1" i18n>Alias:</span>
					<button title="Copy alias to clipboard." [appCopyToClipboard]="term.alias" [appCopyToClipboardIcon]="true" i18n-title type="button" class="button-link">
						{{ term.alias }}
					</button>
				</div>
				<div class="contact-name" *ngIf="term.documents[term.activeVersion]?.publishedBy; else createdBy">
					<span class="pr-1" i18n>Published by:</span>
					<span>
						<a
							href="mailto:{{ term.documents[term.activeVersion].publishedBy.email }}"
							class="mr-1"
							style="font-weight: 400;"
						>{{ term.documents[term.activeVersion].publishedBy.firstName + ' ' + term.documents[term.activeVersion].publishedBy.lastName }}</a>
						<span class="document-date" i18n>at {{ term.documents[term.activeVersion].publishedBy.ts | date: 'medium' }}</span>
					</span>
				</div>

				<ng-template #createdBy>
					<div class="contact-name" *ngIf="term.documents[term.latestVersion]?.createdBy">
						<span class="pr-1" i18n>Created by:</span>
						<span>
							<a
								href="mailto:{{ term.documents[term.latestVersion].createdBy.email }}"
								class="mr-1"
								style="font-weight: 400;"
							>{{ term.documents[term.latestVersion].createdBy.firstName + ' ' + term.documents[term.latestVersion].createdBy.lastName }}</a>
							<span class="document-date" i18n>at {{ term.documents[term.latestVersion].createdBy.ts | date: 'medium' }}</span>
						</span>
					</div>
				</ng-template>
			</div>

			<div class="col-sm-auto pr-0">
				<button
					class="border-0 badge badge-pill badge-warning pl-3 pb-1"
					*ngIf="term.hasDraft"
					(click)="viewLegal(term, term.latestVersion, termState.draft)"
					type="button"
					title="View draft"
				>
					<span>{{ term.documents[term.latestVersion]?.displayVersion }}</span>
					<span class="material-icons pl-2" style="font-size: 12px !important">remove_red_eye</span>
				</button>

				<button
					class="border-0 badge badge-pill publish-badge badge-success pl-3 pb-1 ml-2"
					*ngIf="term?.activeVersion"
					(click)="viewLegal(term, term.activeVersion, termState.live)"
					title="View active"
				>
					<span>{{ term.documents[term.activeVersion].displayVersion }}</span>
					<span class="material-icons pl-2" style="font-size: 12px !important">remove_red_eye</span>
				</button>
			</div>

			<div class="col-sm-auto small-btn app-legal__actions">
				<button
					type="button"
					mat-icon-button
					[matMenuTriggerFor]="legalDetailsActionMenu"
					[disabled]="!editable"
				>
					<mat-icon class="material-icons">more_vert</mat-icon>
				</button>
				<mat-menu #legalDetailsActionMenu="matMenu">
					<button
						mat-menu-item
						i18n
						title="Edit document"
						i18n-title
						(click)="editLegal(term)"
						type="button"
						class="app-legal__edit"
					>Edit document</button>
					<button
						mat-menu-item
						i18n
						title="Delete version"
						i18n-title
						*ngIf="!term?.activeVersion"
						(click)="confirmDeleteLegal(term)"
						type="button"
						class="app-legal__delete"
					>Delete document</button>
					<button
						mat-menu-item
						i18n
						title="Associated app keys"
						i18n-title
						(click)="viewAppKeyAssociation(term)"
						type="button"
						class="app-legal__view-app-keys"
					>View associated app keys</button>
				</mat-menu>
			</div>
		</div>
		<!-- END App Legals -->
	</app-loader-wrapper>
	<!-- END Body -->
</div>
